import { useContext } from 'react';
import { appEnvironmentContext } from './app-environment-context';

export function useAppEnvironment() {
    const appEnvironment = useContext(appEnvironmentContext);
    if (appEnvironment == null) throw new Error('useAppEnvironment needs to be used in an <AppEnvironmentProvider>');

    return appEnvironment;
}
